"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var store = new Map();
var getDocId = function getDocId(kind, storyName) {
  return kind + "." + storyName;
};

var getDocs = exports.getDocs = function getDocs(kind, storyName) {
  var id = getDocId(kind, storyName);

  if (!store.has(id)) {
    return {};
  }

  return store.get(id);
};

var setDocs = exports.setDocs = function setDocs(kind, storyName) {
  var docs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var id = getDocId(kind, storyName);
  store.set(id, docs);
};